import { DEPLOYMENT_ID_COOKIE_NAME, DEPLOYMENT_ID_HEADER_NAME } from '@layers/web/constants/skew-protection.ts'

export const useSkewProtection = () => {
  const { public: { VERCEL_DEPLOYMENT_ID } } = useRuntimeConfig()

  const nuxtApp = useNuxtApp()

  const isSkewed = computed({
    set: (value) => (nuxtApp.$config.public.skewed = value),
    get: () => nuxtApp.$config.public.skewed,
  })

  const checkForSkew = async (): Promise<boolean> => {
    if (isSkewed.value) {
      return true
    }

    try {
      const response = await fetch(
        '/localapi/deployment-id',
        {
          headers: {
            [DEPLOYMENT_ID_HEADER_NAME]: '',
          },
        }
      )

      // If we get a different deployment ID in response headers, we have skew
      const responseDeploymentId = (await response.json()).deploymentId

      const isSkewedResponse = (
        responseDeploymentId &&
        VERCEL_DEPLOYMENT_ID &&
        responseDeploymentId !== VERCEL_DEPLOYMENT_ID
      )

      isSkewed.value = isSkewedResponse
      return isSkewedResponse
    } catch {
      // If we can't check, assume no skew
      return false
    }
  }

  const clearServiceWorkersCache = async () => {
    if (!window.caches) {
      return
    }

    try {
      const cachedKeys = await window.caches.keys()
      await Promise.all(cachedKeys.map(key => caches.delete(key)))
    } catch (e) {
      // window.caches.keys() can throw SecurityError depending on the browser and settings
      console.error(e)
    }
  }

  const reloadToLatestDeployment = async () => {
    await clearServiceWorkersCache()
    reloadNuxtApp()
  }

  const setDeploymentIdCookie = () => {
    if (!VERCEL_DEPLOYMENT_ID) {
      return
    }

    document.cookie = `${DEPLOYMENT_ID_COOKIE_NAME}=${VERCEL_DEPLOYMENT_ID}; path=/_nuxt; SameSite=Strict; Secure`
  }

  return {
    checkForSkew,
    reloadToLatestDeployment,
    clearServiceWorkersCache,
    isSkewed,
    setDeploymentIdCookie,
  }
}